import { render } from "./kidsglass.vue?vue&type=template&id=84414f7a"
import script from "./kidsglass.vue?vue&type=script&lang=js"
export * from "./kidsglass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__